module.exports = __webpack_public_path__ + "static/media/office-day.39206446.webm";